import React from 'react';

export const nl2br = (value?: string) => {
	return value?.split('\n').map((item, key) => {
		return (
			<React.Fragment key={key}>
				{item}
				<br />
			</React.Fragment>
		);
	});
};
